const route = [{ //选择作业类型
    //subject：11-爱尚书法 12-爱尚编程 13-爱尚模型
    path: '/qualityStation/choosetype/:subject',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/release/chooseTaskType.vue'], resolve);
    }
},
{ //选择章节
    path: '/qualityStation/tea/select_chapter',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/release/select_chapter.vue'], resolve);
    }
},
{ //发布作业选择视频
    //sid-爱尚书法 12-爱尚编程 13-爱尚模型
    path: '/qualityStation/select_video/:sid/:type',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/release/chooseVideo.vue'], resolve);
    }
},
{ //生词听写选作业预览发布
    path: '/qualityStation/word/preview',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/release/wordPreview.vue'], resolve);
    }
},
{ //发作业
    path: '/qualityStation/release/:sid/:type',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/release/release.vue'], resolve);
    }
},
// { //发布规范教程
//     path: '/qualityStation/tea/select_gf_video/:sid/:type',
//     component: function (resolve) {
//         require(['VIEWS/qualityStation/tea/release/select_gf_video.vue'], resolve);
//     }
// },
{ //选择学科
    path: '/qualityStation/subjectChoose',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/subjectChoose.vue'], resolve);
    }
},
{ //作业列表
    path: '/szyz/index',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/index.vue'], resolve);
    }
},
{//素质驿站上课提醒
    path: '/classReminder/index',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/reminder/index.vue'], resolve);
    }
},
{//素质驿站上课提醒详情
    path: '/reminder/detail/:unit_id/:message_id',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/reminder/detail.vue'], resolve);
    }
},
{//素质驿站节日通知选择节日通知内容
    path: '/reminder/festivalmodel',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/reminder/festivalModel.vue'], resolve);
    }
},
{//素质驿站发送通知
    path: '/reminder/send',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/reminder/send.vue'], resolve);
    }
},
{//上课提醒设置发送方式
    path: '/reminder/sendtype',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/reminder/sendType.vue'], resolve);
    }
},
{//上课提醒设置发送时间
    path: '/reminder/sendtime',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/reminder/sendTime.vue'], resolve);
    }
},
{//选择接收班级
    path: '/reminder/chooseUnit',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/reminder/chooseUnit.vue'], resolve);
    }
},
{//选择接收学生
    path: '/reminder/chooseStu',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/reminder/chooseStu.vue'], resolve);
    }
},
{//选择接收学生
    path: '/qualityStation/require',
    component: function (resolve) {
        require(['VIEWS/qualityStation/tea/release/sf_task_require.vue'], resolve);
    }
},
]
export default route